export const minimumRequiredPasswordLength = 8